<template>
  <div class="dft-container" :style="container_Style">
    <div v-if="type == '1'" class="dft-white" :style="white_Style">
    </div>
    <div v-if="type == '2'" class="dft-line" :style="line_Style">
    </div>
  </div>
</template>

<script>

export default {
  props: {
    compData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      showDialog: false
    }
  },
  watch: {
    // compData: {
    //   handler: function(newVal){
    //     if(newVal){
    //       this.$nextTick(() => {
    //         // console.log('comp--D-ata',newVal)
    //       });
    //     }
    //   },
    //   deep: true
    // }
  },
  computed: {
    // 数据 1 辅助空白, 2 辅助线
    type () {
      return this.compData[0]?.value
    },
    // 样式
    container_Style () {
      return {
        [this.compData[3]?.key]: this.compData[3]?.value
      }
    },
    white_Style () {
      return {
        [this.compData[1]?.key]: this.compData[1]?.value + 'px'
      }
    },
    line_Style () {
      return {
        [this.compData[2]?.key]: this.compData[2]?.value + ' ' + this.compData[4]?.value
        // [this.compData[4]?.key]: this.compData[4]?.value,
      }
    }
  },
  created () {
  },

  mounted () {
    this.$nextTick(() => {
    })
  },

  methods: {
    initData () {
    }
  }
}
</script>

<style lang="scss" scoped>
.dft-container{
  width: 100%;
  box-sizing: border-box;
  min-height: 4px;
}
.dft-white{
  width: 100%;
}
.dft-line{
  width: 100%;
  margin-top: 10px;
  padding-bottom: 10px;
  border: 0;
}
</style>
